
























import { Vue, Prop, Component } from 'vue-property-decorator'

import Checkbox from '@/components/Checkbox.vue'
import BankPaymentBody from '@/components/modals/BankPaymentBody.vue'

import Booking from '@/models/booking'

import { isMedExperience } from '@/globalMixin'

@Component({
  components: {
    Checkbox,
    BankPaymentBody,
  },
})
export default class EnrollTabBankPayment extends Vue {
  @Prop() booking!: Booking
  @Prop() termsAccepted!: boolean
  @Prop() paymentCode!: string
  @Prop() bankTransferTemplate!: string

  get termsLink(): string {
    return isMedExperience()
      ? 'https://www.medexperience.com/booking-terms'
      : 'https://www.sail-croatia.com/booking-terms'
  }
}
